import { createAsyncThunk } from '@reduxjs/toolkit';
import { Role } from 'common/types/Entities';

import { APIUserRoleMembershipDelete, APIUserRoleMembershipPost } from '../UserRoleMemberships/UserRoleMemberships.api';

import { APIUserRolesGetList } from './UserProfileRoles.api';

export const fetchUserProfileRoles = createAsyncThunk(
    'userProfileRoles/fetchUserProfileRoles',
    async (item: { tenantId: string, userId: string }) =>
    {
        const { userId, tenantId } = item;
        const response = await APIUserRolesGetList({ userId, tenantId });
        return _formatUserProfileRoleMembershipResponse(response.data);
    }
);

export const postUserProfileRoleMembership = createAsyncThunk('userProfileRoles/postUserProfileRoleMembership', async (item: {
    tenantId: string,
    roleId: string,
    userId: string
}) => {
    return APIUserRoleMembershipPost(item);
});

export const deleteUserProfileRoleMembership = createAsyncThunk('userProfileRoles/deleteUserProfileRoleMembership', async (item: {
    tenantId: string,
    roleId: string,
    userId: string
}) => {
    return APIUserRoleMembershipDelete(item);
});

const _formatUserProfileRoleMembershipResponse = (rows: {
    userId: string;
    tenantId: string;
    userGroupId?: string;
    userGroupName?: string;
    role: Role;
}[]) => {
    return rows.map(({ role, userGroupId, userGroupName }) =>
        ({ ...role, userGroupId, userGroupName })) || [];
};
